export default function BusinessCooperation() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block px-3 py-1 rounded-full text-xs font-medium border border-primary-300 text-primary-700 bg-primary-50 mb-4">
              商务合作
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-black text-foreground-900 mb-3">
              与51暗网合作
            </h2>
            <p className="text-foreground-600 text-sm max-w-lg mx-auto leading-relaxed">
              51暗网拥有庞大的年轻用户群体，期待与您携手共创更多可能性
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="bg-background-100 rounded-lg border border-background-200/70 p-6 hover:border-primary-200 transition-colors">
              <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-50 text-primary-600 text-xl mb-4">
                <i className="ri-advertisement-line"></i>
              </span>
              <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">广告投放</h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                在51暗网首页、分类页及文章页进行品牌曝光。支持横幅广告、信息流广告、文章植入等多种形式，精准触达年轻娱乐消费群体。
              </p>
              <ul className="space-y-1.5">
                {['首页轮播广告位', '文章内页横幅', '侧边栏推荐位', '信息流原生广告'].map((item) => (
                  <li key={item} className="flex items-center gap-2 text-xs text-foreground-500">
                    <i className="ri-checkbox-circle-line text-accent-500 text-sm"></i>
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div className="bg-background-100 rounded-lg border border-background-200/70 p-6 hover:border-accent-200 transition-colors">
              <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-50 text-accent-600 text-xl mb-4">
                <i className="ri-article-line"></i>
              </span>
              <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">内容合作</h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                与51暗网联合打造定制内容栏目。通过深度报道、专题策划、品牌故事等形式，将品牌信息自然融入热门八卦追踪内容中。
              </p>
              <ul className="space-y-1.5">
                {['品牌专题策划', '软文内容植入', '联合活动推广', '达人矩阵合作'].map((item) => (
                  <li key={item} className="flex items-center gap-2 text-xs text-foreground-500">
                    <i className="ri-checkbox-circle-line text-accent-500 text-sm"></i>
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div className="bg-background-100 rounded-lg border border-background-200/70 p-6 hover:border-secondary-200 transition-colors">
              <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-secondary-50 text-secondary-600 text-xl mb-4">
                <i className="ri-team-line"></i>
              </span>
              <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">战略合作</h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                面向娱乐经纪公司、MCN机构、直播平台等的深度战略合作。包括独家爆料渠道共建、数据共享、品牌联名等。
              </p>
              <ul className="space-y-1.5">
                {['独家爆料渠道', '数据资源共享', '品牌联合营销', '行业研究报告'].map((item) => (
                  <li key={item} className="flex items-center gap-2 text-xs text-foreground-500">
                    <i className="ri-checkbox-circle-line text-accent-500 text-sm"></i>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="mt-10 bg-background-100 rounded-lg border border-background-200/70 p-6 md:p-8">
            <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
              <div>
                <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2">平台核心数据</h3>
                <p className="text-sm text-foreground-600">基于2026年上半年统计，数据持续增长中</p>
              </div>
              <div className="grid grid-cols-2 md:flex md:items-center gap-6 md:gap-10">
                <div className="text-center">
                  <span className="block text-2xl md:text-3xl font-black text-primary-500">5000万+</span>
                  <span className="text-xs text-foreground-500">月均浏览量</span>
                </div>
                <div className="text-center">
                  <span className="block text-2xl md:text-3xl font-black text-accent-500">128万</span>
                  <span className="text-xs text-foreground-500">日活跃用户</span>
                </div>
                <div className="text-center">
                  <span className="block text-2xl md:text-3xl font-black text-secondary-500">5.6万+</span>
                  <span className="text-xs text-foreground-500">累计爆料</span>
                </div>
                <div className="text-center">
                  <span className="block text-2xl md:text-3xl font-black text-foreground-900">82%</span>
                  <span className="text-xs text-foreground-500">18-35岁用户占比</span>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-10 text-center">
            <p className="text-sm text-foreground-600 mb-4">
              有意合作？欢迎通过下方联系方式与我们取得联系，我们将在24小时内回复
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="mailto:hello@chigualiao.cn"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-mail-line"></i>
                hello@chigualiao.cn
              </a>
              <span className="text-sm text-foreground-400">或使用下方投稿表单联系我们</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}